<div class="modal fade" id="modalProductImport" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">NHẬP FILE</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body col-sm-12 d-flex justify-content-center gap-3">
                <div class="col-sm-2 d-flex gap-3">
                    <InputImportComponent
                            :label="dataModal.file.label"
                            :id="dataModal.file.id"
                            :placeholder="dataModal.file.placeholder"
                            :value-default="dataModal.file.value"
                            @inputValue="onChange($event, dataModal.file.id)"
                            :required="dataModal.file.required"
                            :disabled="dataModal.file.disable"
                            :error-text="dataModal.file.error"
                            :is-error="dataModal.file.isError"
                            @fileSelected="actionFileSelected($event)"
                    ></InputImportComponent>
                </div>
                <div class="col-sm-2 d-flex gap-5">
                    <SelectNormal
                            :label="dataModal.name.label"
                            :id="dataModal.name.id"
                            :placeholder="dataModal.name.placeholder"
                            :value-default="dataModal.name.value"
                            @inputValue="onChange($event, dataModal.name.id)"
                            :required="dataModal.name.required"
                            :disabled="dataModal.name.disable"
                            :options="dataModal.name.options"
                    ></SelectNormal>
                </div>
                <div class="col-sm-2 d-flex gap-5">
                    <SelectNormal
                            :label="dataModal.warehouse_id.label"
                            :id="dataModal.warehouse_id.id"
                            :placeholder="dataModal.warehouse_id.placeholder"
                            :value-default="dataModal.warehouse_id.value"
                            @inputValue="onChange($event, dataModal.warehouse_id.id)"
                            :required="dataModal.warehouse_id.required"
                            :disabled="dataModal.warehouse_id.disable"
                            :options="dataModal.warehouse_id.options"
                    ></SelectNormal>
                </div>
                <div class="col-sm-2 d-flex gap-5">
                    <InputTextNormal
                            :label="dataModal.table_use.label"
                            :id="dataModal.table_use.id"
                            :placeholder="dataModal.table_use.placeholder"
                            :value-default="dataModal.table_use.value"
                            @inputValue="onChange($event, dataModal.table_use.id)"
                            :required="dataModal.table_use.required"
                            :disabled="dataModal.table_use.disable"
                    ></InputTextNormal>
                </div>
                <div class="col-sm-2 d-flex gap-5">
                    <InputTextNormal
                            :label="dataModal.type.label"
                            :id="dataModal.type.id"
                            :placeholder="dataModal.type.placeholder"
                            :value-default="dataModal.type.value"
                            @inputValue="onChange($event, dataModal.type.id)"
                            :required="dataModal.type.required"
                            :disabled="dataModal.type.disable"
                    ></InputTextNormal>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button class="btn btn-primary" @click="importFile">Áp dụng</button>
            </div>
        </div>
    </div>
</div>
